import { mapProps, compose, setDisplayName } from 'react-recompose';


export default keys => compose(
    setDisplayName('omitProps'),
    mapProps((props) => {
        const omitted = { ...props };

        keys.forEach((p) => {
            delete omitted[p];
        });

        return omitted;
    }),
);
